import debug from '../utils/console'

const logger = debug.extend('plugins:google-tag-manager')

export default defineNuxtPlugin((nuxtApp) => {
  const { googleTagManagerId, redesignedNtpPaths } = useAppConfig()
  const { gtag, initialize } = useGtag()
  const route = useRoute()

  if (!googleTagManagerId) {
    logger.warn('Google Tag Manager: Gtag ID not available in app config')
    return
  }

  initialize(googleTagManagerId)

  // Maintain window.dataLayer field for legacy pages
  if (!import.meta.dev && !redesignedNtpPaths.includes(route.path)) {
    gtag('js', new Date())
    gtag('config', 'UA-62117061-22')
  }

  nuxtApp.hook('app:mounted', () => {
    try {
      window.googletag = window.googletag || { cmd: [] }
      window.googletag.cmd.push(() => {
        if (!window.googletag.pubads) {
          logger.error('addEventListener: Gtag pubads not found')
          return
        }
        window.googletag
          .pubads()
          .addEventListener('slotRenderEnded', setupNativeAdAsFallback)
      })
    } catch (err) {
      logger.error('Error mounting event listeners for native fallback', err)
    }
  })
})
